import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-benefika-charcoal text-white pt-20 pb-10 border-t-4 border-benefika-teal" data-id="element-123">
      <div className="container mx-auto px-4" data-id="element-124">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-125">
          <div className="md:col-span-4" data-id="element-126">
            <div className="flex flex-col items-start mb-6" data-id="element-127">
              <span className="text-3xl font-extrabold text-white tracking-tight" data-id="element-128">
                Benefika
              </span>
              <span className="text-xs font-medium text-benefika-teal uppercase tracking-widest mt-1" data-id="element-129">
                by TicketMaestro
              </span>
            </div>
            <p className="text-gray-400 mb-8 leading-relaxed pr-4" data-id="element-130">
              Soluciones innovadoras de fidelización para potenciar la relación
              con sus clientes, usuarios o grupos de interés y transformar
              transacciones en lealtad a largo plazo.
            </p>
          </div>

          <div className="md:col-span-2 md:col-start-6" data-id="element-131">
            <h3 className="font-bold text-lg mb-6 text-white" data-id="element-132">Empresa</h3>
            <ul className="space-y-3" data-id="element-133">
              <li data-id="element-134">
                <a href="/nosotros" className="text-gray-400 hover:text-benefika-teal transition-colors" data-id="element-135">
                  Sobre Nosotros
                </a>
              </li>
              <li data-id="element-136">
                <a href="/#caracteristicas" className="text-gray-400 hover:text-benefika-teal transition-colors" data-id="element-137">
                  ¿Por qué elegirnos?
                </a>
              </li>
              <li data-id="element-138">
                <a href="/programas-clientes" className="text-gray-400 hover:text-benefika-teal transition-colors" data-id="element-139">
                  Casos de Éxito
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3" data-id="element-140">
            <h3 className="font-bold text-lg mb-6 text-white" data-id="element-141">
              Sobre TicketMaestro
            </h3>
            <ul className="space-y-3" data-id="element-142">
              <li data-id="element-143">
                <a href="https://www.ticketmaestro.net/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-benefika-teal transition-colors inline-flex items-center gap-1.5" data-id="element-144">
                  Ir a TicketMaestro
                  <ExternalLinkIcon size={14} data-id="element-145" />
                </a>
              </li>
              <li data-id="element-146">
                <a href="https://www.ticketmaestro.net/privacidad" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-benefika-teal transition-colors" data-id="element-147">
                  Privacidad y Protección de Datos
                </a>
              </li>
              <li data-id="element-148">
                <a href="https://www.ticketmaestro.net/terminos" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-benefika-teal transition-colors" data-id="element-149">
                  Términos y Condiciones
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3" data-id="element-150">
            <h3 className="font-bold text-lg mb-6 text-white" data-id="element-151">Contacto</h3>
            <ul className="space-y-3" data-id="element-152">
              <li data-id="element-153">
                <a href="mailto:contacto@benefika.net" className="text-gray-400 hover:text-benefika-teal transition-colors flex items-center" data-id="element-154">
                  contacto@benefika.net
                </a>
              </li>
              <li className="text-gray-400 pt-2" data-id="element-155">
                Edificio The Point, Of. 1803
                <br data-id="element-156" />
                Guayaquil, Ecuador
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-157">
          <p data-id="element-158">
            &copy; {new Date().getFullYear()} Benefika. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-159">Una marca de TicketMaestro</p>
        </div>
      </div>
    </footer>;
};
export default Footer;